import { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

const AgeVerificationModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const ageVerified = localStorage.getItem("ageVerified");
    if (!ageVerified) {
      setIsOpen(true);
    }
  }, []);

  const handleConfirm = () => {
    localStorage.setItem("ageVerified", "true");
    setIsOpen(false);
  };

  const handleDecline = () => {
    window.location.href = "https://www.google.com";
  };

  return (
    <Dialog open={isOpen} onOpenChange={() => {}}>
      <DialogContent 
        className="sm:max-w-md border-primary/20"
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader className="text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
            <AlertTriangle className="h-8 w-8 text-primary" />
          </div>
          <DialogTitle className="text-xl font-bold text-center">
            Age Verification Required
          </DialogTitle>
          <DialogDescription className="text-center text-muted-foreground pt-2">
            You must be <span className="font-semibold text-foreground">19 years of age or older</span> to access this website. 
            By entering, you confirm that you meet this age requirement.
          </DialogDescription>
        </DialogHeader>
        
        <div className="mt-6 space-y-3">
          <Button 
            onClick={handleConfirm} 
            className="w-full"
            size="lg"
          >
            I am 19 or older - Enter Site
          </Button>
          <Button 
            onClick={handleDecline} 
            variant="outline" 
            className="w-full"
            size="lg"
          >
            I am under 19 - Exit
          </Button>
        </div>

        <p className="mt-4 text-xs text-center text-muted-foreground">
          By entering our website, you confirm that the information you provide (including date of birth) is accurate and truthful.
        </p>
        <p className="mt-2 text-xs text-center text-muted-foreground">
          All products are sold strictly for research purposes only and are not intended for human consumption.
        </p>
      </DialogContent>
    </Dialog>
  );
};

export default AgeVerificationModal;
